import React, { Component } from "react";
import { withFormsy } from "formsy-react";
import { categoryService } from "../Admin/Categories/services/category.service";
import { AsyncSelect } from "../Shared/Forms";

class CategoryDropDown extends Component {
  state = {
    fetching: false,
    fetched: false,
    response: null,
    error: null
  };

  getAllCategoriesByName = (inputValue, callback) => {
    this.setState({ fetching: true });
    if (inputValue && inputValue.length > 2) {
      categoryService
        .getAllCategories({ name: inputValue })
        .then(response => {
          response && this.setState({ response, error: null, fetching: false });
          callback(response.content);
        })
        .catch(error => this.setState({ error, fetching: false }));
    }
  };

  render() {
    const {
      name,
      value,
      disabled,
      isRequired,
      defaultOptions,
      isMulti
    } = this.props;

    return (
      <div>
        <AsyncSelect
          isMulti={isMulti}
          name={name}
          value={value}
          defaultOptions={defaultOptions}
          title="Categories"
          loadOptions={this.getAllCategoriesByName}
          valueKey="id"
          disabled={disabled}
          labelKey="name"
          validating={disabled}
          innerRef={c => {
            this.categories = c;
          }}
          isClearable={true}
          required={isRequired}
        />
      </div>
    );
  }
}

export default withFormsy(CategoryDropDown);
